import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"

import { cn } from "@/lib/utils"

// Sized to the app's own field geometry (10/12px padding, 8px radius) instead
// of shadcn's h-8. No text-size class: Preflight gives inputs `font: inherit`,
// so they pick up the 12px from the surrounding field label — the behaviour
// the previous stylesheet depended on.
function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "w-full min-w-0 rounded-lg border border-border bg-surface-input px-3 py-2.5 text-foreground transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/15 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
